import { render, staticRenderFns } from "./AllowBlockLists.vue?vue&type=template&id=d4a38ad4&scoped=true&"
import script from "./AllowBlockLists.vue?vue&type=script&lang=ts&"
export * from "./AllowBlockLists.vue?vue&type=script&lang=ts&"
import style0 from "./AllowBlockLists.vue?vue&type=style&index=0&id=d4a38ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a38ad4",
  null
  
)

export default component.exports